<fui-modal (close)="closeModal()" [state]="isOpen()" [maxWidth]="config.maxWidth" [maxHeight]="config.maxHeight">
    <fui-modal-window>
        <fui-modal-window-toolbar (closed)="closeModal()">
        </fui-modal-window-toolbar>
        <fui-modal-window-header>
            <fui-breadcrumbs>
                @for (view of views; track view; let last = $last) {
                    <fui-breadcrumb [title]="view.context.title$()"
                                    [showClose]="last" (removed$)="requestCancel()"></fui-breadcrumb>
                }
            </fui-breadcrumbs>
        </fui-modal-window-header>
        <fui-modal-window-main>
            <ng-template #modalwindowmain></ng-template>
        </fui-modal-window-main>
    </fui-modal-window>
</fui-modal>
